/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'util/PropTypes';


import CompareTable from './CompareTable';

import './CombinedCompareTable.scss';

import StringResources from 'nls/StringResources';
const summaryLabel = StringResources.get('compareTable_SummaryLabel');
const selectionsLabel = StringResources.get('compareTable_SelectionsLabel');

const FullSideList = [ { value:'summary', label: summaryLabel }, { value:'selections', label: selectionsLabel }];
const SummarySideList = [ { value:'summary', label: summaryLabel }];

/**
* Compare Card table
* for showing stats on selection &
*/
@observer
export default class CombinedCompareTable extends Component {
	constructor(props) {
		super(props);

		this.sideHeaderList = [ { value:'summary', label: summaryLabel }];
		this.state = {
			selectedCategory : 'summary'
		};
		this.selectionUpdated = undefined;
	}

	switchTo(category) {
		this.setState( { selectedCategory: category } );
	}

	switchViewOnSelection() {
		const selectionUpdated = this.props.compareModel.selectionUpdated;
		if( this.selectionUpdated === undefined) {
			this.selectionUpdated = selectionUpdated;
		} else {
			if(this.selectionUpdated != selectionUpdated && selectionUpdated >1) {
				this.selectionUpdated = selectionUpdated;
				this.switchTo('selections');
			} else {
				this.selectionUpdated = selectionUpdated;
			}
		}
	}

	render() {

		const compareModel = this.props.compareModel;
		if( !compareModel.showStats) {
			return null;
		}

		const compareTableSummary = compareModel.compareTableSummary || { };
		if( !compareTableSummary.charts || (compareTableSummary.charts && compareTableSummary.charts.length === 0) ) {
			return null; //can't render anything yet
		}
		this.switchViewOnSelection();

		let useSummaryOnly = false;
		const selections = compareModel.getChartSummaryModel('selections');
		if(selections && selections.charts && selections.charts.length > 0 ) {
			this.sideHeaderList = FullSideList;
		} else {
			useSummaryOnly = true;
			this.sideHeaderList = SummarySideList;
		}

		const summaryInfo = {
			title: summaryLabel,
			category: 'summary',
			sideHeaderList: this.sideHeaderList,
			onSwitch: this.switchTo.bind(this)
		};
		const selectionsInfo= {
			title: selectionsLabel,
			category: 'selections',
			sideHeaderList: this.sideHeaderList,
			onSwitch: this.switchTo.bind(this)
		};

		if( useSummaryOnly && this.state.selectedCategory !== 'summary' ) {
			this.setState( { selectedCategory: 'summary' } );
		}

		let info = summaryInfo;
		if( this.state.selectedCategory !== 'summary') {
			info = selectionsInfo;
		}

		return (
			<div className="combinedCompareTable__container">
				<CompareTable options={info} compareModel={compareModel}/>
			</div>
		);

	}
}


CombinedCompareTable.propTypes = {
	compareModel: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/js/components/lwstats/CombinedCompareTable.js